export default defineNuxtRouteMiddleware(async (to) => {
  const { path, query, hash } = to

  // ローマ字表記の旧URL（例: /abashirigawa/）は河川コードのURLへ301リダイレクトする
  const riverName = path.split('/')[1] ?? ''
  const riverCode = (redirectConfig as Record<string, string>)[riverName]
  if (riverCode) {
    const pid = typeof query.pid === 'string' ? query.pid : ''
    // pidが対象の河川コードに属さない場合は河川セグメントなしのURLへ逃がす
    const isInvalidUrl = pid
      ? await $fetch('/api/river/url', { query: { path: riverCode, id: makeTrueId(pid) } })
      : false
    const nextPath = isInvalidUrl ? '/' : `/${riverCode}/`
    const nextRoute = { path: nextPath, query, hash }
    return navigateTo(nextRoute, { redirectCode: 301 })
  }

  if (path.endsWith('/')) return
  const nextPath = path + '/'
  const nextRoute = { path: nextPath, query, hash }
  return navigateTo(nextRoute, { redirectCode: 301 })
})
